import type { MiceEventPremises } from './mice';

/** Quantos dias a ida pode antecipar o início do evento e a volta passar do fim, sem pedido do
 *  viajante por outro dia. */
const MAX_SHIFT_DAYS = 3;

const DAY_MS = 86_400_000;
const shift = (date: string, days: number): string =>
  new Date(Date.parse(`${date}T00:00:00.000Z`) + days * DAY_MS).toISOString().slice(0, 10);

export interface MiceEventDays {
  eventDate: string;
  eventEnd: string | null;
  premises: Pick<MiceEventPremises, 'returnDeparture'> | null;
}

/**
 * A janela padrão da troca de data de um sentido: a ida de `MAX_SHIFT_DAYS` antes do início até o
 * início; a volta do início até `MAX_SHIFT_DAYS` depois do fim. O fim é o mais tarde entre o dia do
 * evento, `eventEnd` e a data da janela da volta nas premissas (a mesma que a recomendação usa).
 * O servidor e o campo de data leem a mesma janela; a data que o viajante pediu passa dela.
 */
export function miceDateWindow(
  direction: 'OUTWARD' | 'RETURN',
  event: MiceEventDays,
): { from: string; to: string } {
  if (direction === 'OUTWARD') {
    return { from: shift(event.eventDate, -MAX_SHIFT_DAYS), to: event.eventDate };
  }
  const ends = [event.eventEnd, event.premises?.returnDeparture?.date];
  const last = ends.reduce<string>((a, b) => (b && b > a ? b : a), event.eventDate);
  return { from: event.eventDate, to: shift(last, MAX_SHIFT_DAYS) };
}
